import React, { useState, useMemo, useEffect } from "react";
import _ from 'lodash';
import {
    Box,

    Stack,
    Typography,
} from "@mui/material";
import { TopicChip as Chip } from "../common/topicChip";
import { generateExcelFile, getNumeric } from '../../../common/utils'
import { MaterialReactTable,useMaterialReactTable } from "material-react-table";
import moment from "moment";
import {Button} from "@mui/material";
const  getExcelColumns=(data)=>{
    return _.map(_.keys(data[0]),it=>({key:it,header:_.startCase(it),formatting:(it=='number'||it=='matchingScore')?{type:'number',format:it=='matchingScore'?"0.00%":null}:{type:'text'}}))
}
const fileName = `Pipeline Score-${moment().format(
    "YYYYMMDD"
  )}-${Math.floor(Math.random() * 1000000)}`
const Result = ({ comparisionData }) => {
    const data = React.useMemo(() => comparisionData, [comparisionData])
   
   const excelColumns=useMemo(()=>getExcelColumns(data),[data])

    const renderCell = (cell) => {

        switch (cell.column.columnDef.accessorKey) {
            case "original":
            case "output":
            case "missingInOutput":
            case "missingInOriginal":
            case "matchingOutput":
                const value = cell.renderedCellValue

                return <Stack spacing={0.5} direction='row' flexWrap={'wrap'} rowGap={0.5} > {_.map(_.uniq(value), it => {

                    const topicName = it?.split(':')[0]
                    const color = it?.split(':')[1]
                    return <Chip label={topicName} color={color == 'Positive' ? 'success' : 'error'} sx={{ color: '#fff', width: 'fit-content' }} size="small" />
                })}</Stack>

            case "matchingScore":
                return getNumeric(cell.renderedCellValue, true) + '%'
            default:
                return (
                    <Typography sx={{ whiteSpace: "pre-wrap", marginTop: "-5px" }}>
                        {cell.renderedCellValue}
                    </Typography>
                );
        }
    };
    const columns = useMemo(
        () => [
            {
                header: 'Review #',
                accessorKey: "number",
                id: "number",
                Cell: renderCell,
                size: 10,
            },
            {
                header: 'Matching Topics',
                accessorKey: "matchingOutput",
                id: "matchingOutput",
                Cell: renderCell,
                size: 10,
            },
            {
                header: 'Missing Topics',
                accessorKey: "missingInOutput",
                id: "missingInOutput",
                Cell: renderCell,
                size: 10,
            },
            {
                header: 'Extra Topics',
                accessorKey: "missingInOriginal",
                id: "missingInOriginal",
                Cell: renderCell,
                size: 10,
            },
            {
                header: 'Matching Score',
                accessorKey: "matchingScore",
                id: "matchingScore",
                Cell: renderCell,
                size: 10,
            },

        ], [data])
        const table=useMaterialReactTable({
            columns,
            data,
           initialState:{
            pagination:{pageSize:50}
           },
           paginationDisplayMode:'pages',
            enableStickyHeader:true,
            enableFullScreenToggle:false,
            enableDensityToggle:false,
            enableColumnFilters:false,
            enableTopToolbar:false,
            enableBottomToolbar:true,
            muiTableContainerProps:{
                sx: {
                    height: 'calc(100vh - 345px)',
                    overflow: 'auto',
                }
            },
            muiTablePaperProps:{
                className: "std_table review-requests",
                sx: {
                    boxShadow: 'none',
                }
            },muiPaginationProps:{
                color: 'primary',
                shape: 'rounded',
                showRowsPerPage: false,
                variant: 'outlined',
            }

        })
    return (
        <Stack spacing={1}>
            <Stack direction={'row'} justifyContent={'end'}>
                <Button disabled={_.size(comparisionData)<=0} onClick={()=>generateExcelFile(data,fileName,excelColumns)}>Export</Button>
            </Stack>
        <MaterialReactTable
        table={table}
        />
        </Stack>
    );
};

export default Result;
